/* eslint-disable */
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import {
    fetchKpis,
    deleteKpi,
    fetchKpiSetListForUser,
    getAllTemplates,
    fetchBcsList
} from '../../actions/kpiActions';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './Styling/Kpilist.css';
import { Tooltip } from "@material-ui/core";

const KpiList = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const kpis = useSelector((state) => state.kpiData.kpis);
    const templates = useSelector((state) => state.kpiData.templates || []);
    const bcsList = useSelector((state) => state.kpiData.kpiBsc || []);

    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({
        capability: '',
        function: '',
        phase: ''
    });

    useEffect(() => {
        dispatch(fetchKpiSetListForUser());
        dispatch(fetchKpis());
        dispatch(getAllTemplates());
        dispatch(fetchBcsList());
    }, [dispatch]);

    useEffect(() => {
        if (kpis) setLoading(false);
    }, [kpis]);

    const toCamelCase = (str) =>
        str
            ?.toLowerCase()
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");

    const uniqueCapabilities = useMemo(() => {
        const values = kpis?.map(k => k.CapabilityID).filter(Boolean) || [];
        return [...new Set(values.map(toCamelCase))];
    }, [kpis]);

    const uniqueFunctions = useMemo(() => {
        const values = kpis?.map(k => k.FunctionID).filter(Boolean) || [];
        return [...new Set(values.map(toCamelCase))];
    }, [kpis]);

    const uniquePhases = useMemo(() => {
        const values = kpis?.map(k => k.PhaseID).filter(Boolean) || [];
        return [...new Set(values.map(toCamelCase))];
    }, [kpis]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleDeleteKpi = (kpiId) => {
        confirmAlert({
            title: 'Confirm Deletion',
            message: 'Are you sure you want to delete this KPI?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        dispatch(deleteKpi({ KPIID: kpiId }));
                        dispatch(fetchKpiSetListForUser());
                        dispatch(fetchKpis());
                    },
                },
                { label: 'No' },
            ],
        });
    };

    const filteredKpis = useMemo(() => {
        return kpis?.filter((kpi) => {
            const cap = toCamelCase(kpi.CapabilityID);
            const fn = toCamelCase(kpi.FunctionID);
            const ph = toCamelCase(kpi.PhaseID);
            return (
                (!filters.capability || cap === filters.capability) &&
                (!filters.function || fn === filters.function) &&
                (!filters.phase || ph === filters.phase)
            );
        });
    }, [kpis, filters]);

    const templateMap = useMemo(() => {
        const map = {};
        templates.forEach((t) => { map[t.template_id] = t.name; });
        return map;
    }, [templates]);

    const bcsMap = useMemo(() => {
        const map = {};
        bcsList.forEach((c) => { map[c.CategoryLookUpId] = c.CategoryName; });
        return map;
    }, [bcsList]);

    const calculateDuration = (start, end) => {
        if (!start || !end) return "-";
        const normalizeDate = (dateStr) =>
            dateStr?.replace(":AM", " AM").replace(":PM", " PM");
        const startDate = new Date(normalizeDate(start));
        const endDate = new Date(normalizeDate(end));
        if (isNaN(startDate) || isNaN(endDate)) return "-";
        const diffMs = endDate - startDate;
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        const diffMonths = Math.floor(diffDays / 30);
        return diffMonths > 0
            ? `${diffMonths} month${diffMonths > 1 ? "s" : ""}`
            : `${diffDays} day${diffDays > 1 ? "s" : ""}`;
    };

    const handleCardClick = (e, kpi) => {
        if (e.target.closest(".btn") || e.target.closest(".delete-btn")) return;
        history.push(`/kpi-setting/0/${kpi.KPIID}`);
    };

    const renderKpiCards = () => {
        if (loading) return <p>Loading KPIs...</p>;
        if (!filteredKpis || filteredKpis.length === 0) return <p>No KPIs available.</p>;

        return filteredKpis.map((kpi) => {
            let cardClass = "card kpi-card h-100 ";
            if (kpi.KPIID === 152) cardClass += "border-success";
            else if (kpi.KPIState === "Active") cardClass += "border-success";
            else if (kpi.KPIState === "Configured") cardClass += "border-warning";
            else cardClass += "border-secondary";

            const isActiveKpi = kpi.KPIID === 152;

            return (
                <div key={`kpi_${kpi.KPIID}`} className="col-12 col-md-4 col-lg-4 mb-4">
                    <div className={cardClass} onClick={(e) => handleCardClick(e, kpi)}>

                        {/* Delete Button */}
                        <Tooltip title="Delete KPI" placement="top">
                            <button
                                className="delete-btn"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteKpi(kpi.KPIID);
                                }}
                            >
                                <i className="fas fa-trash-alt"></i>
                            </button>
                        </Tooltip>

                        {/* Header */}
                        <div className="card-header d-flex justify-content-between align-items-center bg-light">
                            <h6 className="mb-0 d-flex align-items-center">
                                <div className="icon-circle bg-primary text-white mr-2">
                                    <i className="fas fa-chart-line"></i>
                                </div>
                                {kpi.KPITitle}
                            </h6>
                            <span
                                className={`badge ${kpi.KPIID === 152
                                    ? "badge-success"
                                    : kpi.KPIState === "Active"
                                        ? "badge-success"
                                        : kpi.KPIState === "Configured"
                                            ? "badge-warning text-dark"
                                            : "badge-secondary"
                                    }`}
                            >
                                {kpi.KPIID === 152 ? "Active" : kpi.KPIState}
                            </span>

                        </div>

                        {/* Body */}
                        <div className="card-body small">
                            <p><i className="fas fa-bullseye text-primary"></i> <strong>Metrics:</strong> {kpi.BusinessMetrics || "-"}</p>
                            <p><i className="fas fa-users text-success"></i> <strong>Stakeholders:</strong> {kpi.Stakeholders || "-"}</p>
                            <p><i className="fas fa-chart-area text-info"></i> <strong>Target Growth/Reduction:</strong> {kpi.ExpectedTargetGrowthAmount || "-"}</p>
                            <p><i className="fas fa-layer-group text-warning"></i> <strong>Baseline:</strong> {kpi.BaselineValue || "-"}</p>
                            <p><i className="fas fa-database text-danger"></i> <strong>Data Template:</strong> {templateMap[kpi.TemplateID] || "-"}</p>
                            <p><i className="fas fa-clock text-secondary"></i> <strong>Duration:</strong> {calculateDuration(kpi.KPIInitiationDate, kpi.BusinessOutComeTargetDate)}</p>
                            <p><i className="fas fa-project-diagram text-dark"></i> <strong>BSC Category:</strong> {bcsMap[kpi.CategoryLookUpId] || "-"}</p>
                        </div>

                        {/* Footer Buttons */}
                        <div className="card-footer d-flex justify-content-between align-items-center">
                            <Link
                                to={`/kpi-setting/0/${kpi.KPIID}`}
                                className="btn btn-outline-primary btn-sm w-50 mr-2"
                            >
                                <i className="fas fa-edit mr-1"></i> Edit
                            </Link>
                            <div className="d-flex align-items-center w-50 justify-content-center">
                                <Link
                                    to={`/kpi-setting/dashboard/${kpi.KPIID}`}
                                    className="btn btn-outline-success btn-sm w-100 position-relative"
                                >
                                    <i className="fas fa-chart-line mr-1"></i> Dashboard
                                    {isActiveKpi && (
                                        <span className="active-badge">Active</span>
                                    )}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
    };


    return (
        <div className="row kpi-setting-sec">
            <div className="col-md-12">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <p className="heading mb-0">Performance Measuring</p>
                    <Link to="/kpi-setting/create" className="btn btn-primary">
                        <i className="fas fa-plus-circle"></i> Add new KPI
                    </Link>
                </div>

                {/* Filters */}
                <div className="filters-section d-flex align-items-center mb-4">
                    <select className="form-control mr-3" name="capability" value={filters.capability} onChange={handleFilterChange}>
                        <option value="">Select Capability</option>
                        {uniqueCapabilities.map((cap) => (
                            <option key={cap} value={cap}>{cap}</option>
                        ))}
                    </select>
                    <select className="form-control mr-3" name="function" value={filters.function} onChange={handleFilterChange}>
                        <option value="">Select Function</option>
                        {uniqueFunctions.map((fn) => (
                            <option key={fn} value={fn}>{fn}</option>
                        ))}
                    </select>
                    <select className="form-control mr-3" name="phase" value={filters.phase} onChange={handleFilterChange}>
                        <option value="">Select Phase</option>
                        {uniquePhases.map((ph) => (
                            <option key={ph} value={ph}>{ph}</option>
                        ))}
                    </select>
                </div>

                {/* KPI Cards */}
                <div className="row kpi-cards-container">{renderKpiCards()}</div>
            </div>
        </div>
    );
};

export default KpiList;
